import { fetchWithTimeout } from "../utils/fetchWithTimeout";

export type EmailJobStatus =
  | "queued"
  | "processing"
  | "retry_wait"
  | "sent"
  | "failed";


export interface WithdrawalEmailJobStatus {
  id: number;
  withdrawal_id: number;
  version: number;
  status: EmailJobStatus;
  attempt_count: number;
  max_attempts: number;
  last_error_user: string | null;
  queued_at: string;
  last_attempt_at: string | null;
  next_attempt_at: string | null;
  sent_at: string | null;
  failed_at: string | null;
}


export interface EmailQueueSummary {
  queued: number;
  processing: number;
  retry_wait: number;
  failed: number;

  pending_total: number;

  next_attempt_at: string | null;

  has_errors: boolean;
}


export interface EmailQueueItem {
  job_id: number;
  withdrawal_id: number;
  withdrawal_number: number | null;
  version: number;

  material_number: string;
  material_text: string;

  status: EmailJobStatus;

  attempt_count: number;
  max_attempts: number;

  last_error_user: string | null;

  queued_at: string;
  last_attempt_at: string | null;
  next_attempt_at: string | null;

  sent_at: string | null;
  failed_at: string | null;
}


async function apiFetch<T>(
  url: string,
  options?: RequestInit
): Promise<T> {
  const response = await fetchWithTimeout(url, {
    credentials: "include",
    ...options,
    headers: {
      Accept: "application/json",
      ...options?.headers,
    },
  }, 5000);

  if (response.status === 401) {
    throw new Error("not_authenticated");
  }

  if (!response.ok) {
    throw new Error(
      `API-Fehler ${response.status}`
    );
  }

  return response.json();
}


export function fetchEmailStatus(): Promise<EmailQueueSummary> {
  return apiFetch<EmailQueueSummary>(
    "/api/email/status"
  );
}


export function fetchEmailQueue(): Promise<EmailQueueItem[]> {
  return apiFetch<EmailQueueItem[]>(
    "/api/email/queue"
  );
}


export function retryEmail(
  withdrawalId: number
): Promise<unknown> {
  return apiFetch(
    `/api/withdrawals/${withdrawalId}/email/retry`,
    {
      method: "POST",
    }
  );
}

export function fetchWithdrawalEmailStatus(withdrawalId: number): Promise<WithdrawalEmailJobStatus> {
  return apiFetch<WithdrawalEmailJobStatus>(`/api/withdrawals/${withdrawalId}/email`, { cache: "no-store" });
}
